import type { MentionMode } from '../../integrations/IntegrationMentions';
import INTEGRATION_MENTIONS, {
  Behaviors,
} from '../../integrations/IntegrationMentions';
import type { IntegrationMentionType } from '../types';

export const SLAB_REGEX = new RegExp(
  `^(?:https?://)?${document.location.host}/(drafts|posts|users|topics|groups)/(?:[^#]*-)?([a-z0-9]+(?:#.+)?)/?`,
);

export const parsePostMentionId = (postMentionId: string) => {
  const [id, anchor] = postMentionId.split('#');
  return { id: id || postMentionId, anchor };
};

function matchMention(url: string): {
  modes: [MentionMode, ...MentionMode[]];
  value: {
    type: IntegrationMentionType;
    id: string;
  };
} | null {
  // eslint-disable-next-line no-restricted-syntax
  for (const type of Behaviors.Mention) {
    const { mentionType, parseUrl, modes } = INTEGRATION_MENTIONS[type];
    const id = parseUrl(url);
    if (id) return { modes, value: { id, type: mentionType } };
  }

  if (SLAB_REGEX.test(url)) {
    const [path, id] = url.match(SLAB_REGEX)?.slice(1) ?? [];
    if (id) {
      const modes: [MentionMode] = ['mention'];
      switch (path) {
        case 'users':
          return { modes, value: { id, type: 'user' } };
        case 'topics':
          return { modes, value: { id, type: 'topic' } };
        case 'groups':
          return { modes, value: { id, type: 'group' } };
        default:
          return { modes, value: { id, type: 'post' } };
      }
    }
  }

  return null;
}

export default matchMention;
